module.exports = __webpack_public_path__ + "img/05.6e38521d.jpg";